export const adjustFontSizeAvatar = (initialsLength: number) => {
  const size = 8 + 2 * (5 - initialsLength);
  return Math.max(10, Math.min(20, size));
};
